import { render, staticRenderFns } from "./Deplesi.vue?vue&type=template&id=534fea19&"
import script from "./Deplesi.vue?vue&type=script&lang=js&"
export * from "./Deplesi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports